var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "containerBox" }, [
        _c("h2", { staticClass: "marginTop30" }, [
          _vm._v("官方选房师绑定楼盘")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "marginTop30" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    _vm.centerDialogVisible = true
                  }
                }
              },
              [_vm._v("新增人员")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "marginTop30" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.tableData, border: "" }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "saleInfo.user_name",
                    label: "姓名",
                    width: "120",
                    align: "center"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "name",
                    label: "绑定楼盘",
                    width: "500",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "estates" },
                            _vm._l(scope.row.estateInfos, function(
                              item,
                              index
                            ) {
                              return _c("div", { key: index }, [
                                _c("div", [
                                  _vm._v(_vm._s(item.real_estate_name))
                                ])
                              ])
                            }),
                            0
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "name",
                    label: "标签",
                    width: "280",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope1) {
                        return [
                          _vm._l(scope1.row.labels, function(tag, index) {
                            return _c("el-tag", { key: index }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(tag) +
                                  "\n            "
                              )
                            ])
                          }),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "button-new-tag",
                              attrs: { size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.showInput(scope1.row)
                                }
                              }
                            },
                            [_vm._v("修改")]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "photo",
                    label: "照片",
                    width: "280",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope2) {
                        return [
                          _c("input", {
                            attrs: { type: "file" },
                            on: {
                              change: function($event) {
                                return _vm.chooseImage($event, scope2.row)
                              }
                            }
                          }),
                          _vm._v(" "),
                          scope2.row.photo
                            ? _c("div", { staticClass: "imageBox" }, [
                                _c("img", {
                                  staticStyle: { width: "100px" },
                                  attrs: {
                                    src: scope2.row.photo,
                                    preview: "1",
                                    mode: "widthFix"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.delImage(scope2.row)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.upImage(scope2.row)
                                }
                              }
                            },
                            [_vm._v("\n              保存")]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "photo",
                    label: "操作",
                    width: "180",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope3) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.handleClick(scope3.row, 1)
                                }
                              }
                            },
                            [_vm._v("\n              新增")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.handleClick(scope3.row, 2)
                                }
                              }
                            },
                            [_vm._v("\n              删除")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "绑定",
            visible: _vm.centerDialogVisible,
            width: "30%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.centerDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "occupancyContainer" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchUserName,
                  expression: "searchUserName"
                }
              ],
              attrs: { type: "text", placeholder: "用户搜索" },
              domProps: { value: _vm.searchUserName },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchUser.apply(null, arguments)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchUserName = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  _vm.nameSearchUsers.length
                    ? _c(
                        "div",
                        { staticClass: "normal" },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                placeholder: "绑定楼盘",
                                "default-first-option": "",
                                "remote-method": _vm.searchEstate,
                                remote: ""
                              },
                              model: {
                                value: _vm.search,
                                callback: function($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search"
                              }
                            },
                            _vm._l(_vm.matchEstates, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.real_estate_name,
                                  value: item.id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  Object.keys(_vm.userInfo).length !== 0
                    ? _c(
                        "div",
                        [
                          _c("el-tag", [
                            _vm._v(" " + _vm._s(_vm.userInfo.user_name) + " ")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.nameSearchUsers, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "margin-top": "20px"
                        }
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            width: "50px",
                            height: "50px",
                            "border-radius": "50%"
                          },
                          attrs: { src: item.head_url, alt: "没有头像" }
                        }),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(_vm._s(item.user_name))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.selectUser(item)
                                  }
                                }
                              },
                              [_vm._v("选定")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.centerDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleEstate(1)
                    }
                  }
                },
                [_vm._v("新 增")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "标签", visible: _vm.dialogVisible, width: "30%" },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _vm._l(_vm.label, function(tag, index) {
            return _c(
              "el-tag",
              {
                key: index,
                attrs: { closable: "", "disable-transitions": false },
                on: {
                  close: function($event) {
                    return _vm.handleClose(tag)
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(tag) + "\n    ")]
            )
          }),
          _vm._v(" "),
          _vm.inputVisible
            ? _c("el-input", {
                ref: "saveTagInput",
                staticClass: "input-new-tag",
                attrs: { size: "small" },
                on: { blur: _vm.handleInputConfirm },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleInputConfirm.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.inputValue,
                  callback: function($$v) {
                    _vm.inputValue = $$v
                  },
                  expression: "inputValue"
                }
              })
            : _c(
                "el-button",
                {
                  staticClass: "button-new-tag",
                  attrs: { size: "small" },
                  on: { click: _vm.showInput2 }
                },
                [_vm._v("新增标签")]
              ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.modifyTag()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "操作",
            visible: _vm.handleVisible,
            width: "30%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.handleVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "center" } },
            [
              _vm.handleType === 1
                ? _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "选择楼盘",
                        "default-first-option": "",
                        "remote-method": _vm.searchEstate,
                        remote: ""
                      },
                      model: {
                        value: _vm.search,
                        callback: function($$v) {
                          _vm.search = $$v
                        },
                        expression: "search"
                      }
                    },
                    _vm._l(_vm.matchEstates, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.real_estate_name, value: item.id }
                      })
                    }),
                    1
                  )
                : _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "选择楼盘" },
                      model: {
                        value: _vm.search,
                        callback: function($$v) {
                          _vm.search = $$v
                        },
                        expression: "search"
                      }
                    },
                    _vm._l(_vm.estateInfos, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.real_estate_name, value: item.id }
                      })
                    }),
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.handleVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleBind(1)
                    }
                  }
                },
                [_vm._v("新增")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.handleBind(2)
                    }
                  }
                },
                [_vm._v("删除")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02371c1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02371c1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/officialAgent.vue
// module id = null
// module chunks = 